import React, { FunctionComponent } from 'react'
import Svg, { G, Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

type Props = {
  size?: number | string
  fillColor?: string
}

export const Pills: FunctionComponent<Props> = ({ size = 32, fillColor }) => {
  const { colors } = useTheme()
  const fill = fillColor || colors.iconActive

  return (
    <Svg width={size} height={size} viewBox='0 0 32 32' fill='none' testID={tID('Pills')}>
      <G transform='translate(3.3346 3.3346)'>
        <Path
          d='M25.332 7.30273C25.332 5.35207 24.5734 3.51867 23.1934 2.13867C21.8147 0.758672 19.98 0 18.0293 0C16.0786 0 14.2441 0.760005 12.8654 2.13867L2.13867 12.8652C0.758672 14.2452 0 16.0786 0 18.0293C0 19.98 0.758672 21.8134 2.13867 23.1934C3.51734 24.5734 5.35207 25.332 7.30273 25.332C9.2534 25.332 11.088 24.572 12.4666 23.1934L17.8148 17.8454C17.8281 17.8334 17.8441 17.8294 17.8574 17.8174C17.8708 17.8054 17.8748 17.7881 17.8854 17.7747L23.1934 12.4668C24.5734 11.0868 25.332 9.25207 25.332 7.30273ZM11.5241 22.2493C10.3961 23.3773 8.8974 23.9987 7.30273 23.9987C5.70807 23.9987 4.20938 23.3773 3.08138 22.2493C1.95338 21.1213 1.33203 19.6227 1.33203 18.028C1.33203 16.4333 1.95338 14.9346 3.08138 13.8066L7.99333 8.89486L16.436 17.3372L11.5241 22.2493ZM17.3787 16.3949L8.93604 7.95215L13.8081 3.08008C14.9361 1.95208 16.4346 1.33073 18.0293 1.33073C19.624 1.33073 21.1227 1.95208 22.2507 3.08008C23.3787 4.20808 24 5.70677 24 7.30143C24 8.8961 23.3787 10.3948 22.2507 11.5228L17.3787 16.3949ZM7.26139 13.2588C7.52139 13.5188 7.52139 13.9415 7.26139 14.2015L6.24805 15.2148C5.29738 16.1668 4.82796 17.4829 4.95996 18.8255C4.99463 19.1909 4.72799 19.5187 4.36133 19.5534C4.33866 19.5547 4.31743 19.556 4.29476 19.556C3.95609 19.556 3.66667 19.2988 3.632 18.9548C3.46133 17.2134 4.07067 15.5068 5.30534 14.2708L6.31869 13.2575C6.58002 12.9988 7.00139 12.9988 7.26139 13.2588Z'
          fill={fill}
        />
      </G>
    </Svg>
  )
}
